import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';


const initialValues = {
};

const validationSchema = Yup.object({
});

const activeCase = [
    {
        id: 0,
        title: "غیر فعال"
    }, {
        id: 1,
        title: "فعال"
    }
]

const Create = () => {

    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness')
    const { addData: addDataService } = useEntityCrud('Service/SetService')
    const { readData: readDataGroup } = useEntityCrud('Group/GetAllGroups')
    const [groupList, setGroupList] = useState([]);
    const [activeList, setActiveList] = useState([]);
    const [businessList, setBusinessList] = useState([]);
    const navigate = useNavigate();
    const [orgAddress, setOrgAddress] = useState({
        buisnessId: "",
        groupId: ""
    })

    useEffect(() => {

        readDataGroup(orgAddress.buisnessId.value).then(res => {
            setGroupList(res.data.result.map(item => ({ value: item.id, label: item.title })))
        });

        setActiveList(activeCase.map(item => ({ value: item.id, label: item.title })))

        readDataBusiness().then(res => {
            setBusinessList(res.data.result)
        });

    }, [])

    const onSubmit = (values) => {
        const postedData = {
            title: values.title,
            deliverType: values.deliverType,
            isActive: 0,
            groupId: orgAddress.groupId.value
        };
        addDataService(postedData).then(res => {
            if (res.status === 200) {
                if (res.data.status === false) {
                    res.data.errors.map(error => toast.error(error.message));
                }
                else {
                    navigate("/service");
                    toast.success('خدمت با موفقیت در سیستم ثبت شد');
                }
            } else
                res.data.errors.map(error => toast.error(error.message));
        })
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/service', { replace: true });
    }

    return (
        <div className="card">
            <div className="card-header  d-flex justify-content-between">
                <div className="card-title">
                  {/*   <i className='fa fa-plus px-1'></i> */}
                    ایجاد سرویس جدید</div>
                <a className='backIconLink' onClick={handleBack}> <i className='fa fa-arrow-left'
                    title="بازگشت"> </i> </a>

            </div>
            <div className="card-body">
                <Form formik={formik} groupList={groupList} setGroupList={setGroupList} activeList={activeList} isEditMode={false}
                    businessList={businessList} orgAddress={orgAddress} setOrgAddress={setOrgAddress}
                />
            </div>
        </div>
    );
}

export default Create;